export const getExperiment = (state, name) => state.experiments[name] === 'true';
//# sourceMappingURL=experiments-selectors.js.map